<template>
  <div>
    <v-divider class="my-5" />
    <label-icon label="Cromossomos" icon="bubble_chart" bold />
    <div v-if="hasChromosomes">
      <v-list two-line>
        <v-list-group
          v-for="(diagnoseChromosome, index) in diagnoseChromosomes"
          :key="index"
          class="elevation-1"
        >
          <template v-slot:activator>
            <v-list-item class="pa-7">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  Cromossomos {{ diagnoseChromosome.chromosome.order }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <div class="pa-3 black--text body-2">
            <property-value
              property="Descrição"
              :value="diagnoseChromosome.chromosome.description"
            />
            <text-editor
              :value="diagnoseChromosome.therapistComments"
              label="Comentários aos terapeutas"
              return-value="therapistComments"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />
            <text-editor
              :value="diagnoseChromosome.patientComments"
              label="Comentários ao paciente"
              return-value="patientComments"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />
            <switch-editor
              :value="diagnoseChromosome.hidePatient"
              label="Esconder ao paciente na diagnose"
              return-value="hidePatient"
              class="mb-3"
              @save="changeProperties"
              @open="selectIndex(index)"
            />
            <v-row justify="center" class="py-5">
              <v-btn dark color="red" @click="removeChromosome(index)">
                <v-icon class="mr-2">delete</v-icon>
                Remover Cromossomo
              </v-btn>
            </v-row>
          </div>
        </v-list-group>
      </v-list>
    </div>
    <div v-else class="mt-5">Nenhum cromossomo adicionado.</div>
  </div>
</template>

<script>
export default {
  name: "ChromosomesSection",
  data: () => ({
    selectedIndex: -1,
  }),
  computed: {
    hasChromosomes() {
      return this.$store.getters["diagnosis/hasChromosomes"];
    },
    diagnoseChromosomes() {
      return this.$store.state.diagnosis.diagnose.chromosomes;
    },
  },
  methods: {
    changeProperties(property) {
      this.$store.commit("diagnosis/changePropertyChromosomes", {
        index: this.selectedIndex,
        property,
      });
    },
    selectIndex(index) {
      this.selectedIndex = index;
    },
    removeChromosome(index) {
      this.$store.commit("diagnosis/removeChromosome", index);
    },
  },
};
</script>

<style scoped></style>
